<div class="popup-comp">
  <div class="modal-header confirm-profile-header-style" ngbAutofocus>
    <h4 class="modal-title">
      {{'profile.confirmProfileSettings'| cxTranslate}}
    </h4>
  </div>

  <div class="modal-body confirm-profile-body-style">
    <section *ngIf="!isSaveComplete; else saveCompleteBody">
      <p>{{'profile.yearlyConfirm'| cxTranslate}}</p>
      <!-- =========================Name Form============================================ -->
      <section class="row">

        <section class="col-md-9 col-9 col-sm-9">
          <h3 class="nameform-header">
            <span class="header-Css">
              {{'profile.name'| cxTranslate}}
            </span>
          </h3>
        </section>

        <section class="col-md-3 col-3 col-sm-3">
          <h3 class="float-right">
            <img alt="" src="../../../../../assets/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              *ngIf="nameEditIsNotClicked">
            <span class="edit-Option" (click)="editNameField()" *ngIf="nameEditIsNotClicked">
              {{'profile.edit'| cxTranslate}}
            </span>
          </h3>
        </section>

      </section>

      <section class="container p-0 " [ngClass]="{'margin-Down':nameEditIsNotClicked,
        'edited-Fields-Margin-Value':!nameEditIsNotClicked}">
        <section class="row" *ngIf="nameEditIsNotClicked">
          <section class="col-md-12 ">
            <label class="inner-Headers"> {{'profile.firstName'| cxTranslate}}</label>
          </section>
          <section class="col-md-12 inner-Headers-section">
            <span class="inner-Content inner-Content-Font-Color">{{
              nameForm.get("actualFirstName").value
              }}</span>
          </section>
          <section class="col-md-12">
            <label class="inner-Headers">{{'profile.lastName'| cxTranslate}}</label>
          </section>
          <section class="col-md-12 inner-Headers-section">
            <span class="inner-Content inner-Content-Font-Color">{{
              nameForm.get("actualLastName").value
              }}</span>
          </section>
        </section>

        <section class="row" [formGroup]="nameForm" *ngIf="!nameEditIsNotClicked">
          <section class="col-md-12 ">
            <label class="inner-Headers">{{'profile.firstName'| cxTranslate}}</label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="actualFirstName" [ngClass]="{
                  required:
                  nameForm.get('actualFirstName').invalid &&
                    (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
                }" (input)="onNameFormChange('actualFirstName')" />
            <span class="text-danger" *ngIf="
                  nameForm.get('actualFirstName').value.length==0 &&
                  (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
                ">{{'profile.requiredError'| cxTranslate}}</span>
            <span class="text-danger" *ngIf="
                nameForm.get('actualFirstName').value.length!=0 &&
                nameForm.get('actualFirstName').invalid &&
                (nameForm.get('actualFirstName').touched ||nameForm.get('actualFirstName').dirty)
              ">{{'profile.invalidName'| cxTranslate}}</span>
          </section>

          <section class="col-md-12">
            <label class="inner-Headers">{{'profile.lastName'| cxTranslate}}</label>
          </section>

          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="actualLastName" [ngClass]="{
                  required:
                    nameForm.get('actualLastName').invalid &&
                    (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty)
                }" (input)="onNameFormChange('actualLastName')" />
            <span class="text-danger" *ngIf="
                (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty) &&
                  nameForm.get('actualLastName').value.length == 0
                ">{{'profile.requiredError'| cxTranslate}}</span>
            <span class="text-danger" *ngIf="
                nameForm.get('actualLastName').value.length!=0 &&
                nameForm.get('actualLastName').invalid &&
                (nameForm.get('actualLastName').touched ||nameForm.get('actualLastName').dirty)
              ">{{'profile.invalidName'| cxTranslate}}</span>
          </section>
        </section>

        <section class="row w-100  btn-Row" *ngIf="!nameEditIsNotClicked">
          <button class="btn btn-secondary mr-4" (click)="cancelNameUpdate()">
            {{'profile.cancel'|cxTranslate}}
          </button>
          <button class="btn btn-primary" (click)="updateNameField()"
            [disabled]="
                  nameForm.get('actualFirstName').invalid || nameForm.get('actualLastName').invalid || !isNameFormChanged">
            {{'profile.update'|cxTranslate}}
          </button>
        </section>
      </section>

      <hr />

      <!-- =========================Role============================================ -->
      <section class="row ">
        <section class="col-md-9 col-9 col-sm-9">
          <h3><span class="header-Css">{{'profile.role'| cxTranslate}}</span></h3>
        </section>
        <section class="col-md-3 col-3 col-sm-3">
          <h3 class="float-right">
            <img alt="" src="../../../../../assets/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              *ngIf="roleEditIsNotClicked">
            <span class="edit-Option" (click)="editRoleField()" *ngIf="roleEditIsNotClicked">{{'profile.edit'|
              cxTranslate}}</span>
          </h3>
        </section>
      </section>

      <section class="container p-0" [ngClass]="{'margin-Down':roleEditIsNotClicked,
        'edited-Fields-Margin-Value':!roleEditIsNotClicked}">
        <section class="row" *ngIf="roleEditIsNotClicked">
          <section class="col-md-12">
            <span class="inner-Content inner-Content-Font-Color">{{ displayRoleofUser }}</span>
          </section>
        </section>

        <section class="row " *ngIf="!roleEditIsNotClicked">
          <section class="col-md-12 col-12 col-sm-12 col-lg-12 col-xs-12 col-xl-6
             fields-Margin-Value role-Margin-Bottom user-Profile">

            <ng-select class="w-100" [items]="roleOfUserArray" bindLabel="name" bindValue="code" [multiple]="false"
              name="chosenRoleofUser" [clearable]="false" placeholder="Select Role" [(ngModel)]="chosenRoleofUser"
              (change)="onRoleChange()">
            </ng-select>
          </section>
        </section>

        <section class="row w-100  btn-Row" *ngIf="!roleEditIsNotClicked">
          <button class="btn btn-secondary mr-4" (click)="cancelRoleUpdate()">
            {{'profile.cancel'|cxTranslate}}
          </button>
          <button class="btn btn-primary" (click)="updateRoleField()" [disabled]="!isRoleChanged">
            {{'profile.update'|cxTranslate}}
          </button>
        </section>

      </section>
      <hr />

      <!--================================Email============================== -->
      <section class="row">
        <section class="col-md-9 col-9 col-sm-9">
          <h3 class="m-0"><span class="header-Css"> {{"profile.email"|cxTranslate}}</span></h3>
        </section>

        <section class="col-md-3 col-3 col-sm-3">
          <h3 class="float-right">
            <img alt="" src="../../../../../assets/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              *ngIf="emailEditIsNotClicked" />
            <span class="edit-Option" (click)="editEmailField()" *ngIf="emailEditIsNotClicked">{{'profile.edit'|
              cxTranslate}}</span>
          </h3>
        </section>
      </section>

      <section class="container p-0" [ngClass]="{'margin-Down':emailEditIsNotClicked,
        'edited-Fields-Margin-Value':!emailEditIsNotClicked}">
        <section class="row" *ngIf="emailEditIsNotClicked">
          <section class="col-md-12">
            <span class="inner-Content inner-Content-Font-Color">{{ emailForm.get("emailId").value }}</span>
          </section>
        </section>

        <section class="row" [formGroup]="emailForm" *ngIf="!emailEditIsNotClicked">
          <section class="col-md-12 ">
            <label class="inner-Headers"> {{"profile.email"|cxTranslate}}</label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="emailId" [ngClass]="{
                  required:
                    (emailForm.get('emailId').value.length == 0  || emailForm.get('emailId').invalid) &&
                    (emailForm.get('emailId').touched ||  emailForm.get('emailId').dirty)
                }" (input)="onEmailFormChange()" />

            <span class="text-danger" *ngIf="emailForm.get('emailId').invalid &&
              (emailForm.get('emailId').dirty || emailForm.get('emailId').touched)
              && emailForm.get('emailId').value.length!=0">
              {{'profile.invalidEmail'| cxTranslate}}
            </span>
            <span class="text-danger" *ngIf="(emailForm.get('emailId').dirty || emailForm.get('emailId').touched)
              && emailForm.get('emailId').value.length==0 "> {{'profile.requiredError'| cxTranslate}}
            </span>
          </section>

          <section class="col-md-12">
            <label class="inner-Headers">{{'profile.confirmEmail'| cxTranslate}}</label>
          </section>
          <section class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="confirmEmailId" [ngClass]="{
                  required:
                    (emailForm.get('confirmEmailId').value.length == 0 ||
                    emailForm.get('confirmEmailId').value != emailForm.get('emailId').value) &&
                    (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty)
                }" />
            <span class="text-danger" *ngIf="emailForm.get('confirmEmailId').invalid &&
                (emailForm.get('confirmEmailId').dirty || emailForm.get('confirmEmailId').touched)
                && emailForm.get('confirmEmailId').value.length != 0">
              {{'profile.invalidEmail'| cxTranslate}}
            </span>
            <span class="text-danger" *ngIf="
                  emailForm.get('confirmEmailId').value !=
                  emailForm.get('emailId').value &&  emailForm.get('confirmEmailId').value != 0 &&
                  !emailForm.get('confirmEmailId').invalid &&
                  (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty)
                ">
              {{"profile.fieldMismatch"|cxTranslate}}
            </span>
            <span class="text-danger" *ngIf="
                emailForm.get('confirmEmailId').value == 0
                  &&
                  (emailForm.get('confirmEmailId').touched || emailForm.get('confirmEmailId').dirty)
              ">
              {{"profile.requiredError"|cxTranslate}}
            </span>

          </section>
        </section>
        <section class="row w-100  btn-Row" *ngIf="!emailEditIsNotClicked">
          <button class="btn btn-secondary mr-4" (click)="cancelEmailUpdate()">
            {{'profile.cancel'|cxTranslate}}
          </button>
          <button class="btn btn-primary" (click)="updateEmailField()" [disabled]="
            emailForm.invalid ||
              (emailForm.get('confirmEmailId').value !=
                emailForm.get('emailId').value) || !isEmailFormChanged
            ">
            {{'profile.update'|cxTranslate}}

          </button>
        </section>
      </section>
      <hr />

      <!--===============================Communication=================================-->
      <section class="row">
        <section class="col-md-9 col-9 col-sm-9">
          <h3 class="m-0"><span class="header-Css">{{"profile.communication"|cxTranslate}}</span></h3>
        </section>

        <section class="col-md-3 col-3 col-sm-3">
          <h3 class="float-right">
            <img alt="" src="../../../../../assets/icons/{{baseSiteId}}/editIcon.png" class="edit-Icon-Image"
              *ngIf="commConfmEditIsNotClicked" />
            <span class="edit-Option" (click)="commConfmEditIsNotClicked = false"
              *ngIf="commConfmEditIsNotClicked">{{'profile.edit'|
              cxTranslate}}</span>
          </h3>
        </section>
      </section>

      <section class="container p-0" [ngClass]="{'margin-Down':commConfmEditIsNotClicked,
         'edited-Fields-Margin-Value':!commConfmEditIsNotClicked,'emailDiv-Top':!commConfmEditIsNotClicked}">
        <!-- when not in edit mode  -->
        <section class="row" *ngIf="commConfmEditIsNotClicked">
          <section class="col-md-12 inner-Content inner-Content-Font-Color">
            <span class="emailConstent-msg"
              *ngIf="emailConsent ==='true'">{{"profile.orderConfirmationEmailYes"|cxTranslate}}</span>
            <span class="emailConstent-msg"
              *ngIf="emailConsent ==='false'">{{"profile.orderConfirmationEmailNo"|cxTranslate}}</span>
          </section>
        </section>

        <!-- <section class="row mt-20" *ngIf="
               commConfmEditIsNotClicked &&
               alternateEmailForm.get('alternateEmailId').value?.length > 0
             ">
          <section class="col-md-12 ">
            <span class="alternate-Mail-Header">{{"profile.alternateEmail"|cxTranslate}}</span>
          </section>
          <section class="col-md-12">
            <span class="alternate-Mail-Value">{{
              alternateMailId
              }}</span>
          </section>
        </section> -->

        <section class="row" *ngIf="!commConfmEditIsNotClicked">
          <section class="col-md-12 col-12 col-sm-12">
            <span class="emailCommunication-Que">{{"profile.orderConfirmationEmailQue"|cxTranslate}}</span>
          </section>

          <section class="row radio-Div w-100">
            <section class="col-xl-2 col-lg-2 col-md-3 col-3 col-sm-3 w-50">
              <div class="custom-control custom-radio radio_grp label-location">
                <input type="radio" id="orderConfirmationYesRadio" name="orderConfirmation" class="custom-control-input"
                  value="true" [(ngModel)]="emailConsent" (ngModelChange)="onCommRadioChange()" />
                <label class="custom-control-label secloct" for="orderConfirmationYesRadio">
                  {{"profile.yes"|cxTranslate}}
                </label>
              </div>
            </section>

            <section class="col-xl-1 col-lg-1 col-md-3 col-3 col-sm-3 p-0 marg-left">
              <div class="custom-control custom-radio radio_grp label-location w-50">
                <input type="radio" id="orderConfirmationNoRadio" name="orderConfirmation" class="custom-control-input"
                  value="false" [(ngModel)]="emailConsent" (ngModelChange)="onCommRadioChange()" />
                <label class="custom-control-label secloct" for="orderConfirmationNoRadio">
                  {{"profile.no"|cxTranslate}}
                </label>
              </div>
            </section>
          </section>

        </section>


        <!-- <section class="row alternate-Email-Row"
          *ngIf="!commConfmEditIsNotClicked && emailConsent == 'true' && !showAlternateEmailField">
          <span (click)="showAlternateEmailField = true" class="addAlternateEmail-Span"
            *ngIf="alternateMailId?.length==0">
            {{"profile.AddAlterMail"|cxTranslate}}</span>
          <span (click)="showAlternateEmailField = true" class="addAlternateEmail-Span"
            *ngIf="alternateMailId?.length>0">
            {{"profile.editAlterEmail"|cxTranslate}}</span>
        </section> -->

        <!-- <section class="row" [formGroup]="alternateEmailForm" *ngIf="showAlternateEmailField"
          [ngStyle]="{'margin-top': '16px'}">
          <section class="col-md-12">
            <label class="inner-Headers">{{"profile.alterMailHeader"|cxTranslate}}</label>
          </section>
          <section class="col-9 col-xs-9 col-sm-10 col-md-10 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="alternateEmailId" [ngClass]="{
                   required: showRedBorder('alternateEmail')
                 }" [placeholder]="getPlaceholder()" />

            <span class="text-danger" *ngIf="alternateEmailForm.get('alternateEmailId').invalid
               && alternateEmailForm.get('alternateEmailId').value.length > 0 &&
               (alternateEmailForm.get('alternateEmailId').dirty ||
               alternateEmailForm.get('alternateEmailId').touched)
               ">
              {{'profile.invalidEmail'| cxTranslate}}</span>

          </section>
          <div class="email-Delete-Div">

            <img src="../../../../../assets/icons/trash.svg" alt=""> <span class="email-Delete"
              (click)="deleteAlternateEmailField()">{{"profile.delete"|cxTranslate}}</span>
          </div>
          <section class="col-md-12">
            <label class="inner-Headers">{{"profile.confirmAlterMail"|cxTranslate}}</label>
          </section>
          <section class="col-9 col-xs-9 col-sm-10 col-md-10 col-lg-12 col-xl-7 fields-Margin-Value-2">
            <input class="form-control  text-Field-Styling" formControlName="confirmAlternateEmailId" [ngClass]="{
                   required: showRedBorder('confirmAlternateEmail') }" [placeholder]="getPlaceholder()" />

            <span class="text-danger" *ngIf="alternateEmailForm.get('confirmAlternateEmailId').invalid &&
                   (alternateEmailForm.get('confirmAlternateEmailId').dirty ||
                   alternateEmailForm.get('confirmAlternateEmailId').touched)
                   && alternateEmailForm.get('confirmAlternateEmailId').value.length != 0">
              {{'profile.invalidEmail'| cxTranslate}}</span>

            <span class="text-danger" *ngIf="
                   alternateEmailForm.get('confirmAlternateEmailId').value !=
                   alternateEmailForm.get('alternateEmailId').value &&
                   alternateEmailForm.get('confirmAlternateEmailId').value.length >
                     0 &&
                    alternateEmailForm.get('confirmAlternateEmailId').valid &&
                   (alternateEmailForm.get('confirmAlternateEmailId').dirty ||
                   alternateEmailForm.get('confirmAlternateEmailId').touched)
                 ">{{"profile.fieldMismatch"|cxTranslate}}</span>
          </section>
        </section> -->
      </section>

      <!-- ==============================alternateEMAILButton================== -->
      <section class="row w-100 btn-Row" *ngIf="!commConfmEditIsNotClicked">
        <button class="btn btn-default cancelBtn-Css" (click)="cancelEmailCommuUpdate()">
          {{'profile.cancel'|cxTranslate}}
        </button>
        <button class="btn btn-info updateBtn-Css" [disabled]="checkForValidity()" (click)="updateEmailCommunField()">
          {{'profile.update'|cxTranslate}}
        </button>

      </section>


    </section>
    <ng-template #saveCompleteBody>
      <section>
        <img src="../../../../../assets/icons/confirmation-positive-green.png" class="positive-green-icon"
          alt="success">
        <span class="settings-saved">{{'profile.settings-saved'|cxTranslate}}</span>
      </section>
    </ng-template>
  </div>

  <div class="modal-footer confirm-profile-footer-style">
    <div class="undo-changes-btngrps">
      <button *ngIf="!isSaveComplete" id="proceedExPopup" type="button" class="btn btn-default blue-button"
        (click)="saveUserDetails()"
        [disabled]="!nameEditIsNotClicked || !roleEditIsNotClicked || !emailEditIsNotClicked || !commConfmEditIsNotClicked">
        {{'profile.save'|cxTranslate}}
      </button>
      <button *ngIf="isSaveComplete" type="button" class="btn btn-default white-button" (click)="closeModal()">
        {{'profile.close'|cxTranslate}}
      </button>
    </div>
  </div>
</div>